import styled from 'styled-components/macro';
import {useRef} from "react";
import useOnClickOutside from "../utils/use_on_click_outside";
import NavLink from "./nav_link";
import {themecolors} from "../utils/themecolors";
import {Calendar, CalendarCheck, Clock, Infinity, Zap} from "lucide-react";

const Item = styled.div``;

const topPath = (community, top, customFeed) => {
    if (customFeed) return `/feed/${customFeed.id}/${customFeed.slug}/?sort=${top}`;
    return community && community !== 'home' ? `/c/${community}/top?sort=${top}` : `/top?sort=${top}`;
}

const TopMenu = styled(({className, onClose, community, customFeed}) => {
    const ref = useRef();
    useOnClickOutside(ref, onClose);
    return (
        <div className={className} ref={ref}>
            <NavLink href={topPath(community, 'hour', customFeed)} onClick={onClose} react_route>
                <Item>
                    <Zap size={18} />
                    Hourly
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'day', customFeed)} onClick={onClose} react_route>
                <Item>
                    <Clock size={18} />
                    Daily
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'week', customFeed)} onClick={onClose} react_route>
                <Item>
                    <Calendar size={18} />
                    Weekly
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'month', customFeed)} onClick={onClose} react_route>
                <Item>
                    <CalendarCheck size={18} />
                    Monthly
                </Item>
            </NavLink>
            <NavLink href={topPath(community, 'all', customFeed)} onClick={onClose} react_route>
                <Item>
                    <Infinity size={18} />
                    All-time
                </Item>
            </NavLink>
        </div>
    )})`
  width: 180px;
  position: absolute;
  margin-left: -40px;
  margin-top: 16px;
  background-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
  border: 1px solid ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : theme.header_menu_border};
  padding: 12px;
  color: ${({theme}) => theme.color.name === 'dark' ? themecolors.pure_white : themecolors.light_high_impact_text};
  font-size: 14px;
  border-radius: 4px;
  font-weight: 400;
  z-index: 2;
  
  ${Item} {
    display: flex;
    align-items: center;
    padding: 8px 8px 8px 0;
    cursor: pointer;
  }
  ${Item} svg {
    margin-right: 8px;
    margin-left: 4px;
    width: 16px;
  }
  
  &:after, &:before {
    bottom: 100%;
    left: 146px;
    border: solid transparent;
    content: "";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }

  &:after {
    border-color: transparent;
    border-bottom-color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_background_2 : themecolors.pure_white};
    border-width: 10px;
    margin-left: -10px;
  }

  &:before {
    border-color: transparent;
    border-bottom-color: ${({theme}) => theme.color.name === 'dark' ? theme.dark_border : theme.header_menu_border};
    border-width: 11px;
    margin-left: -11px;
  }  
`;

export default TopMenu;
